export default __webpack_public_path__ + "static/media/art-3-seed-starting-1.62d1fb0b.jpg";